module.exports = __webpack_public_path__ + "media/packs/images/flags/PL-9a7a9b1c234de8f374fa5cc0473b6c43.png";